import { FocusableContext as Z } from "./SWN3JYXT.js";
import { createHook as $, forwardRef as ee, createElement as re } from "./VOQWLFSQ.js";
import { useEvent as p, useTagName as te, useMergeRefs as oe } from "./5GGHRIN3.js";
import { __objRest as ue, __spreadValues as k, __spreadProps as se } from "./3YLGPPWQ.js";
import { isButton as ne } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
import { addGlobalEventListener as x, isPortalEvent as ie, queueBeforeEvent as v, isSelfTarget as L, isFocusEventOutside as ae } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/events.js";
import { isFocusable as S, getClosestFocusable as fe, hasFocus as R, focusIfNeeded as ce } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/focus.js";
import { disabledFromProps as le, removeUndefinedValues as de } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { isSafari as be } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/QAGXQEUG.js";
import { useRef as pe, useEffect as y, useState as me, useContext as ye, useMemo as Fe } from "react";
var ve = "div", I = be(), we = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
], Ce = Symbol("safariFocusAncestor");
function _(r, u) {
  r && (r[Ce] = u);
}
function Ee(r) {
  const { tagName: u, readOnly: s, type: t } = r;
  return u === "TEXTAREA" && !s || u === "SELECT" && !s ? !0 : u === "INPUT" && !s ? we.includes(t) : !!(r.isContentEditable || r.getAttribute("role") === "combobox" && r.dataset.name);
}
function De(r) {
  return "labels" in r ? r.labels : null;
}
function B(r) {
  return r.tagName.toLowerCase() === "input" && r.type ? r.type === "radio" || r.type === "checkbox" : !1;
}
function Pe(r) {
  return r ? r === "button" || r === "summary" || r === "input" || r === "select" || r === "textarea" || r === "a" : !0;
}
function Te(r) {
  return r ? r === "button" || r === "input" || r === "select" || r === "textarea" : !0;
}
function ge(r, u, s, t, a) {
  return r ? u ? s && !t ? -1 : void 0 : s ? a : a || 0 : a;
}
function w(r, u) {
  return p((s) => {
    r == null || r(s), !s.defaultPrevented && u && (s.stopPropagation(), s.preventDefault());
  });
}
var O = !1, C = !0;
function he(r) {
  const u = r.target;
  u && "hasAttribute" in u && (u.hasAttribute("data-focus-visible") || (C = !1));
}
function Ke(r) {
  r.metaKey || r.ctrlKey || r.altKey || (C = !0);
}
var Ve = $(
  function(u) {
    var s = u, {
      focusable: t = !0,
      accessibleWhenDisabled: a,
      autoFocus: E,
      onFocusVisible: D
    } = s, n = ue(s, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const m = pe(null);
    y(() => {
      t && (O || (x("mousedown", he, !0), x("keydown", Ke, !0), O = !0));
    }, [t]), I && y(() => {
      if (!t) return;
      const e = m.current;
      if (!e || !B(e)) return;
      const o = De(e);
      if (!o) return;
      const i = () => queueMicrotask(() => e.focus());
      for (const b of o)
        b.addEventListener("mouseup", i);
      return () => {
        for (const b of o)
          b.removeEventListener("mouseup", i);
      };
    }, [t]);
    const f = t && le(n), c = !!f && !a, [l, d] = me(!1);
    y(() => {
      t && c && l && d(!1);
    }, [t, c, l]), y(() => {
      if (!t || !l) return;
      const e = m.current;
      if (!e || typeof IntersectionObserver > "u") return;
      const o = new IntersectionObserver(() => {
        S(e) || d(!1);
      });
      return o.observe(e), () => o.disconnect();
    }, [t, l]);
    const G = w(
      n.onKeyPressCapture,
      f
    ), q = w(
      n.onMouseDownCapture,
      f
    ), U = w(n.onClickCapture, f), P = n.onMouseDown, W = p((e) => {
      if (P == null || P(e), e.defaultPrevented || !t) return;
      const o = e.currentTarget;
      if (!I || ie(e) || !ne(o) && !B(o)) return;
      let i = !1;
      const b = () => {
        i = !0;
      }, Y = { capture: !0, once: !0 };
      o.addEventListener("focusin", b, Y);
      const A = fe(o.parentElement);
      _(A, !0), v(o, "mouseup", () => {
        o.removeEventListener("focusin", b, !0), _(A, !1), !i && ce(o);
      });
    }), T = (e, o) => {
      if (o && (e.currentTarget = o), !t) return;
      const i = e.currentTarget;
      i && R(i) && (D == null || D(e), !e.defaultPrevented && (i.dataset.focusVisible = "true", d(!0)));
    }, g = n.onKeyDownCapture, j = p((e) => {
      if (g == null || g(e), e.defaultPrevented || !t || l || e.metaKey || e.altKey || e.ctrlKey || !L(e)) return;
      const o = e.currentTarget;
      v(o, "focusout", () => T(e, o));
    }), h = n.onFocusCapture, H = p((e) => {
      if (h == null || h(e), e.defaultPrevented || !t) return;
      if (!L(e)) {
        d(!1);
        return;
      }
      const o = e.currentTarget, i = () => T(e, o);
      C || Ee(e.target) ? v(e.target, "focusout", i) : d(!1);
    }), K = n.onBlur, N = p((e) => {
      K == null || K(e), t && ae(e) && (e.currentTarget.removeAttribute("data-focus-visible"), d(!1));
    }), X = ye(Z), z = p((e) => {
      t && E && e && X && queueMicrotask(() => {
        R(e) || S(e) && e.focus();
      });
    }), V = te(m), J = t && Pe(V), M = t && Te(V), F = n.style, Q = Fe(() => c ? k({ pointerEvents: "none" }, F) : F, [c, F]);
    return n = se(k({
      "data-focus-visible": t && l || void 0,
      "data-autofocus": E || void 0,
      "aria-disabled": f || void 0
    }, n), {
      ref: oe(m, z, n.ref),
      style: Q,
      tabIndex: ge(
        t,
        c,
        J,
        M,
        n.tabIndex
      ),
      disabled: M && c ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: f ? void 0 : n.contentEditable,
      onKeyPressCapture: G,
      onClickCapture: U,
      onMouseDownCapture: q,
      onMouseDown: W,
      onKeyDownCapture: j,
      onFocusCapture: H,
      onBlur: N
    }), de(n);
  }
);
ee(function(u) {
  const s = Ve(u);
  return re(ve, s);
});
export {
  Ve as useFocusable
};
//# sourceMappingURL=OE2EFRVA.js.map
